// src/pages/tenant/CreateRequest.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Button, TextField, Typography, Paper,
  MenuItem, FormControlLabel, RadioGroup, Radio,
  InputLabel, Select, FormControl
} from '@mui/material';
import { addDoc, collection, serverTimestamp, doc, getDoc } from 'firebase/firestore';
import { db, storage } from '../firebase';
import { getAuth } from 'firebase/auth';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import emailjs from 'emailjs-com';



export default function CreateRequest() {
  const navigate = useNavigate();
  const auth = getAuth();

  // initialize EmailJS
  useEffect(() => {
    emailjs.init('5od5RiWaN2AsVbXhJ');
  }, []);

  const [category, setCategory] = useState('General');
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');
  const [relatedToPast, setRelatedToPast] = useState('no');
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [property, setProperty] = useState('');
  const [priority, setPriority] = useState('Medium');

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async () => {
    try {
      const user = auth.currentUser;
      if (!user) throw new Error('User not logged in');

      let imageUrl = null;
      if (image) {
        const fileRef = ref(storage, `workOrderImages/${user.uid}/${Date.now()}-${image.name}`);
        await uploadBytes(fileRef, image);
        imageUrl = await getDownloadURL(fileRef);
      }

      // fetch profile data
      const profileRef = doc(db, 'users', user.uid);
      const profileSnap = await getDoc(profileRef);
      const profileData = profileSnap.exists() ? profileSnap.data() : {};
      const realTenantName = profileData.name || user.displayName || 'Unknown Tenant';
      const tenantAddress = profileData.address || '';

      // prepare payload
      const payload = {
        type: 'Maintenance request',
        category,
        subject,
        description,
        property: tenantAddress,
        relatedToPast: relatedToPast === 'yes',
        createdAt: serverTimestamp(),
        status: 'New',
        tenantUid: user.uid,
        tenantEmail: user.email || '',
        tenantName: realTenantName,
        imageUrl,
        property,
        priority
      };

      // save to Firestore
      const docRef = await addDoc(collection(db, 'workOrders'), payload);

      // send email via EmailJS
      const templateParams = {
        order_id: docRef.id,
        date: new Date().toLocaleString(),
        tenant_name: realTenantName,
        tenant_email: user.email,
        property: tenantAddress,
        priority,
        subject,
        description
      };

// …after you’ve built templateParams…

        emailjs.send(
  'service_jszer4l',
  'template_yfnkz6f',
  templateParams,
  '5od5RiWaN2AsVbXhJ'  // ← your Public Key here
)
          .then(() => console.log('Email sent to admin!'))
          .catch(err => console.error('EmailJS error:', err));
              

      // navigate back
      navigate('/tenant');

    } catch (error) {
      console.error('Error submitting request:', error);
      alert('Something went wrong. Please try again.');
    }
  };

  return (
    <Box maxWidth="600px" mx="auto" my={5}>
      <Typography variant="h5" mb={2}>Request details</Typography>
      <Paper elevation={3} sx={{ padding: 3, borderRadius: 3 }}>
        <Typography variant="subtitle2" gutterBottom>Type</Typography>
        <Box mb={2}>
          <Button variant="outlined" disabled fullWidth>
            Maintenance request
          </Button>
        </Box>

        <FormControl fullWidth margin="normal">
          <InputLabel>Category</InputLabel>
          <Select
            value={category}
            label="Category"
            onChange={(e) => setCategory(e.target.value)}
          >
            <MenuItem value="General">General</MenuItem>
            <MenuItem value="Plumbing">Plumbing</MenuItem>
            <MenuItem value="Electrical">Electrical</MenuItem>
            <MenuItem value="Heating">Heating</MenuItem>
          </Select>
        </FormControl>

        {/* Uncomment and configure if you want tenant to select property and priority manually:
        <FormControl fullWidth margin="normal">
          <InputLabel>Property</InputLabel>
          <Select
            value={property}
            label="Property"
            onChange={(e) => setProperty(e.target.value)}
          >
            <MenuItem value="Property A">Property A</MenuItem>
            <MenuItem value="Property B">Property B</MenuItem>
            <MenuItem value="Property C">Property C</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel>Priority</InputLabel>
          <Select
            value={priority}
            label="Priority"
            onChange={(e) => setPriority(e.target.value)}
          >
            <MenuItem value="High">High</MenuItem>
            <MenuItem value="Medium">Medium</MenuItem>
            <MenuItem value="Low">Low</MenuItem>
          </Select>
        </FormControl>
        */}

        <Typography mt={2} variant="body2">
          Does this request relate to a past request?
        </Typography>
        <RadioGroup
          row
          value={relatedToPast}
          onChange={(e) => setRelatedToPast(e.target.value)}
        >
          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="no" control={<Radio />} label="No" />
        </RadioGroup>

        <TextField
          label="Subject"
          fullWidth
          margin="normal"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />
        <TextField
          label="Description"
          fullWidth
          multiline
          rows={4}
          margin="normal"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <Box mt={3}>
          <Typography variant="body2" color="text.secondary">Attachments</Typography>
          <Button component="label" variant="outlined" sx={{ mt: 1 }}>
            Upload Image
            <input hidden type="file" accept="image/*" onChange={handleFileChange} />
          </Button>

          {imagePreview && (
            <Box mt={2}>
              <img src={imagePreview} alt="Preview" style={{ width: '100%', borderRadius: 8 }} />
            </Box>
          )}
        </Box>

        <Button
          variant="contained"
          color="success"
          fullWidth
          sx={{ mt: 3, borderRadius: 3 }}
          onClick={handleSubmit}
        >
          Submit Request
        </Button>
      </Paper>
    </Box>
  );
}
